// src/contexts/IncidentReportDetailModalContext.tsx
import { ReactSimpleComponentProps } from '@/custom-types';
import { useState } from 'react';
import { IncidentReportDetailModalContext } from './IncidentReportDetailContext';

export const IncidentReportDetailModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [incidentReportId, setIncidentReportId] = useState<string | null>(null);

  const openModal = (id: string) => {
    setIncidentReportId(id);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setIncidentReportId(null);
  };

  return (
    <IncidentReportDetailModalContext.Provider value={{ isOpen, openModal, closeModal, incidentReportId }}>
      {children}
    </IncidentReportDetailModalContext.Provider>
  );
};
